import { Link } from '@tanstack/react-router'

interface BreadcrumbItem {
  label: string
  to?: string
}

interface Props {
  items: BreadcrumbItem[]
}

export function ToolBreadcrumb({ items }: Props) {
  return (
    <nav aria-label="breadcrumb" className="mb-6 hidden text-sm text-muted-foreground sm:block">
      <ol className="flex flex-wrap items-center">
        {items.map((item, i) => (
          <li key={i} className="flex items-center">
            {i > 0 && (
              <span aria-hidden="true" className="mx-2">
                /
              </span>
            )}
            {item.to ? (
              <Link to={item.to} className="hover:text-foreground">
                {item.label}
              </Link>
            ) : (
              <span aria-current="page" className="text-foreground">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
